document.addEventListener("DOMContentLoaded", () => {
  const priceElement = document.querySelector("product-price-element");

  if (!priceElement) return;

  const rrps = JSON.parse(priceElement.dataset.rrps || "{}");
  const productId = priceElement.dataset.id;

  window.on(
    `theme:product:${productId}:variantChanged.ProductPrice`,
    ({ detail: { variant } }) => {

        console.log("Variant ID:", variant.id);
        console.log("RRP map:", rrps);
        console.log("Matched RRP:", rrps[String(variant.id)]);

      const rrpContainer = document.querySelector("[data-product-rrp]");
      const rrpPrice = document.querySelector("[data-product-rrp-price]");

      if (!rrpContainer || !rrpPrice) return;

      const rrp = rrps[String(variant.id)];

      if (rrp != null && rrp !== "") {
        rrpPrice.textContent = priceElement.formatMoney(rrp);
        rrpContainer.hidden = false;
      } else {
        rrpContainer.hidden = true;
      }
    }
  );
});